import { render, staticRenderFns } from "./CxcDrs.vue?vue&type=template&id=464f60a7"
import script from "./CxcDrs.vue?vue&type=script&lang=js"
export * from "./CxcDrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports